import { categoryTab } from '@/layout/state/state';
import { matchSingleUrl } from '@/constants/urls';
import searchTabTemplate from './searchTabTemplate';

export default {
  ...searchTabTemplate(matchSingleUrl(['search']), ({ search }) => search.run),
  componentState: ({ url }) => categoryTab(url),
};
